import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import styled from 'src/ui/library/styled';
import styles from './styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';

const StyledLinearProgress = withStyles({
  root: {
    position: 'absolute',
    right: -1,
    left: -1,
    bottom: -1,
    height: '3px',
  },
  colorPrimary: {
    backgroundColor: 'transparent',
  },
  barColorPrimary: {
    backgroundColor: '#000',
  },
})(LinearProgress);

class ButtonBase extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.node,
    noMaxWidth: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    noMaxWidth: false,
    className: '',
  };

  render() {
    const { onClick, disabled, children, classes, noMaxWidth, className, isLoading, ...otherProps } = this.props;
    return (
      <Button
        disabled={disabled}
        onClick={onClick}
        fullWidth={true}
        classes={{
          root: classes.root, // class name, e.g. `classes-nesting-root-x`
          label: disabled ? classes.labelDisabled : classes.label, // class name, e.g. `classes-nesting-label-x`
          disabled: classes.disabled,
        }}
        className={isLoading ? `no-pointer-events ${className}` : className}
        {...otherProps}>
        {!isLoading && children}
        {isLoading && 'Loading...'}
        {isLoading && <StyledLinearProgress variant="indeterminate" />}
      </Button>
    );
  }
}

export { ButtonBase };
export default styled(ButtonBase)(styles);
